<template>
    <b-col class="AddNewChild" lg="12">
        <!--SEARCH CHILDREN-->
        <b-row>
            <b-col lg="6">
                <b-row>
                    <h2>1. Search Children</h2>
                    <p>You must first perform a search to ensure that the child does not already exist in Olive Crest's records.</p>
                </b-row>
                <b-row v-show="PageStateComp == 'Initial'">
                    <b-form class="full-width" @submit="SearchClient">
                        <div class="form-group">
                            <label>First Name:</label>
                            <input class="form-control" v-model="ClientSearch.FirstName" required />
                        </div>
                        <div class="form-group">
                            <label>Last Name:</label>
                            <input class="form-control" v-model="ClientSearch.LastName" required />
                        </div>
                        <div class="form-group">
                            <label>DOB:</label>
                            <flat-pickr v-model="ClientSearch.DOB" class="form-control" :config="DateConfig" required></flat-pickr>
                        </div>
                        <div class="form-group">
                            <label>SSN (Leave Blank if Unavailable:</label>
                            <input type="number" class="form-control" v-model="ClientSearch.SSN" />
                        </div>
                        <b-button variant="primary" block type="submit">
                            <font-awesome-icon :icon="['fa', 'search']" />
                            SEARCH
                        </b-button>
                    </b-form>
                </b-row>
                <b-row v-show="PageStateComp == 'ReviewResults' || PageStateComp == 'NewProgramOptions'" cols="1">
                    <b-col>
                        <p>If the child already exists, select them below to start a new program membership. If they don't already exist, then click "Create New Child". Children in red can not be added, as they currently have an active membership in an Olive Crest Foster program.</p>
                        <Vuetable :fields="SearchTableOptions.Fields"
                                  :data="ClientSearchResults"
                                  pagination-path=""
                                  :api-mode="false"
                                  class="vue-datatable"
                                  track-by="SectionName">


                            <template slot="Actions" scope="props">
                                <div class="horizontal-icons-padded">
                                    <span v-if="props.rowData.IsEnrollable"><font-awesome-icon :icon="['fa', 'plus']" v-on:click="AddSelectedClientToNewProgramOptions(props.rowData)" class="pointer olive-green-text" /></span>
                                    <span v-else><font-awesome-icon :icon="['fa', 'ban']" class="red" /></span>
                                </div>
                            </template>
                        </Vuetable>
                        <b-row>
                            <b-col sm md="6" style="margin-bottom:0.5rem">
                                <b-button block @click="NewSearch" variant="warning" style="white-space: normal;">
                                    <font-awesome-icon :icon="['fa', 'redo']" />
                                    NEW SEARCH
                                </b-button>
                            </b-col>
                            <b-col sm md="6">
                                <b-button block @click="AddNewClientToNewProgramOptions" variant="success" style="white-space: normal;">
                                    <font-awesome-icon :icon="['fa', 'user-plus']" />
                                    CREATE NEW CLIENT
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <!--ADD TO PROGRAM-->
            <b-col lg="6">
                <b-row>
                    <h2>2. Add to Program</h2>
                </b-row>
                <b-row v-show="PageStateComp == 'NewProgramOptions'">
                    <b-form class="full-width" @submit="AddClient">
                        <input type="hidden" v-model="NewClientData.ClientID" />
                        <div class="form-group">
                            <label>First Name:</label>
                            <input class="form-control" v-model="NewClientData.FirstName" required readonly />
                        </div>
                        <div class="form-group">
                            <label>Last Name:</label>
                            <input class="form-control" v-model="NewClientData.LastName" required readonly />
                        </div>
                        <div class="form-group">
                            <label>DOB:</label>
                            <flat-pickr v-model="NewClientData.DOB" class="form-control" :config="DateConfigReadonly" required readonly></flat-pickr>
                        </div>
                        <div class="form-group">
                            <label>SSN (Leave Blank if Unavailable:</label>
                            <input type="number" class="form-control" v-model="NewClientData.SSN" />
                        </div>
                        <div class="form-group">
                            <label>Sex:</label>
                            <select class="form-control" v-model="NewClientData.SexID" required>
                                <option v-for="option in SexOptions" :value="option.value">
                                    {{option.text}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Race:</label>
                            <select class="form-control" v-model="NewClientData.RaceID" required>
                                <option v-for="option in RaceOptions" :value="option.value">
                                    {{option.text}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Ethnicity:</label>
                            <select class="form-control" v-model="NewClientData.EthnicityID" required>
                                <option v-for="option in EthnicityOptions" :value="option.value">
                                    {{option.text}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Program Start Date:</label>
                            <flat-pickr v-model="NewClientData.ProgramStartDate" class="form-control" :config="DateConfig" required></flat-pickr>
                        </div>
                        <div class="form-group">
                            <label>Regional Foster Program:</label>
                            <select class="form-control" v-model="NewClientData.SubProgramID" @change="GetAvailableDynamicMethods" required>
                                <option v-for="option in SubProgramOptions" :value="option.value">
                                    {{option.text}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Placing Agency:</label>
                            <select class="form-control" v-model="NewClientData.AgencyID" required>
                                <option v-for="option in AgencyOptions" :value="option.value">
                                    {{option.text}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Case Manager:</label>
                            <select class="form-control" v-model="NewClientData.CaseManagerId">
                                <option value="">None Selected</option>
                                <option v-for="caseManager in CaseManagers" :value="caseManager.Id">
                                    {{caseManager.Person.FullName}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Resource Family (optional):</label>
                            <select class="form-control" v-model="NewClientData.FosterResourceFamilyID">
                                <option value="">None Selected</option>
                                <option v-for="option in PlacementOptions" :value="option.value">
                                    {{option.text}}
                                </option>
                            </select>
                        </div>
                        <b-button variant="success" block type="submit">
                            <font-awesome-icon :icon="['fa', 'plus']" />
                            ADD CHILD TO PROGRAM
                        </b-button>
                    </b-form>
                </b-row>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);
    import { faRedo } from '@fortawesome/free-solid-svg-icons';
    library.add(faRedo);
    import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faUserPlus);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faBan } from '@fortawesome/free-solid-svg-icons';
    library.add(faBan);
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Vuetable from 'vuetable-2/src/components/Vuetable';

    import { EventBus } from '../../../services/event-bus.js';
    export default {
        props: [],
        data: function () {
            return {
                CaseManagers: [],
                PageState: "Initial",
                ClientSearch: {
                    FirstName: "",
                    LastName: "",
                    DOB: "",
                    SSN: ""
                },
                NewClientData: {
                    ClientID: "",
                    FirstName: "",
                    LastName: "",
                    DOB: "",
                    SSN: "",
                    SexID: "",
                    RaceID: "",
                    EthnicityID: "",
                    ProgramStartDate: "",
                    AgencyID: "",
                    SubProgramID: "",
                    FosterResourceFamilyID: "",
                    CaseManagerId: ""
                },
                ClientSearchResults: [],
                AvailablePlacements: [],
                SearchTableOptions: {
                    Fields: [
                        {
                            name: 'Name',
                            title: 'Name',
                        },
                        {
                            name: 'DOB',
                            title: 'DOB',
                            titleClass: '',
                            callback: 'formatDate|MM/DD/YY'
                        },
                        {
                            name: 'SSN',
                            title: 'SSN',
                        },
                        {
                            name: 'ProgramHistory',
                            title: 'Program History',
                        },
                        {
                            name: '__slot:Actions',
                            title: '',
                        }
                    ]
                },
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
                DateConfigReadonly: {
                    dateFormat: 'm/d/Y',
                    allowInput: false,
                    required: true,
                    clickOpens: false
                },
            };
        },
        methods: {
            SearchClient(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FosterClients/SearchExistingClients", this.ClientSearch, this.SearchClientSuccess, () => { }, true);
            },
            SearchClientSuccess(response) {
                this.ClientSearchResults = response.data.data;
                this.PageState = "ReviewResults";
            },
            AddSelectedClientToNewProgramOptions(clientData) {
                let parsedDate = new Date();
                parsedDate = Date.parse(clientData.DOB);
                this.NewClientData.ClientID = clientData.ClientID;
                this.NewClientData.FirstName = clientData.FirstName;
                this.NewClientData.LastName = clientData.LastName;
                this.NewClientData.DOB = parsedDate;
                this.NewClientData.SSN = clientData.SSN;
                this.NewClientData.SexID = clientData.SexID;
                this.NewClientData.RaceID = clientData.RaceID;
                this.NewClientData.EthnicityID = clientData.EthnicityID;
                this.NewClientData.ProgramStartDate = "";
                this.NewClientData.AgencyID = "";
                this.NewClientData.SubProgramID = "";
                this.NewClientData.FosterResourceFamilyID = "";

                this.PageState = 'NewProgramOptions';
            },
            AddNewClientToNewProgramOptions() {
                this.NewClientData.ClientID = "";
                this.NewClientData.FirstName = this.ClientSearch.FirstName;
                this.NewClientData.LastName = this.ClientSearch.LastName;
                this.NewClientData.DOB = this.ClientSearch.DOB;
                this.NewClientData.SSN = this.ClientSearch.SSN;
                this.NewClientData.SexID = "";
                this.NewClientData.RaceID = "";
                this.NewClientData.EthnicityID = "";
                this.NewClientData.ProgramStartDate = "";
                this.NewClientData.AgencyID = "";
                this.NewClientData.SubProgramID = "";
                this.NewClientData.FosterResourceFamilyID = "";

                this.PageState = 'NewProgramOptions';
            },
            NewSearch() {
                this.ResetPage();
            },

            // TO DO: Talk with Tyler. If Client already exists then  none of the client fields are used by the endpoint.
            // Since the client already exists, the client info from the database is used when the Client-subprogram membership is created
            AddClient(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FosterClients/AddClientToProgramMembership", this.NewClientData, this.AddClientSuccess, () => { }, true);

            },
            AddClientSuccess(response) {
                //switch to client record
                this.$store.commit("Clients.ClientProfiles.Append", { ClientProgramMembership: { Id: response.data.data.Id } });
                //this.$set(this.$parent.OpenChildRecords, subProgramMembershipID, childRecordData);
                this.$parent.ChangePaneShown(response.data.data.Id);
                //execute global update
                this.$GlobalUpdate.ExecuteGlobalUpdate();

                //reset page state and form info
                this.ResetPage();
            },
            ResetPage() {
                this.PageState = "Initial";

                this.ClientSearch.FirstName = "";
                this.ClientSearch.LastName = "";
                this.ClientSearch.DOB = "";
                this.ClientSearch.SSN = "";


                this.NewClientData.ClientID = "";
                this.NewClientData.FirstName = "";
                this.NewClientData.LastName = "";
                this.NewClientData.DOB = "";
                this.NewClientData.SSN = "";
                this.NewClientData.SexID = "";
                this.NewClientData.RaceID = "";
                this.NewClientData.EthnicityID = "";
                this.NewClientData.ProgramStartDate = "";
                this.NewClientData.AgencyID = "";
                this.NewClientData.SubProgramID = "";
                this.NewClientData.FosterResourceFamilyID = "";

                this.ClientSearchResults = [];
            },
            GetAvailableDynamicMethods() {
                this.GetAvailablePlacements();
                this.GetAvailableCaseManagerEmployees();
            },
            GetAvailablePlacements() {
                if (this.NewClientData.SubProgramID != "") {
                    this.$MasterAPI.ExecuteRequest("GET", "Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/GetAvailablePlacementsForSubProgram", { subProgramID: this.NewClientData.SubProgramID }, this.GetAvailablePlacementsSuccess, () => { }, false);
                }
            },
            GetAvailablePlacementsSuccess(response) {
                this.AvailablePlacements = response.data.data;
            },
            GetAvailableCaseManagerEmployees() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/EmployeeCaseload/GetCaseManagers", { Id: this.NewClientData.SubProgramID }, this.GetAvailableCaseManagerEmployeesSuccess, () => { }, false);
            },
            GetAvailableCaseManagerEmployeesSuccess(response) {
                this.CaseManagers = response.data.data;
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            Vuetable
        },
        computed: {
            PageStateComp: function () {
                return this.PageState;
            },
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            RaceOptions: function () {
                return this.$store.state.Options.Races;
            },
            EthnicityOptions: function () {
                return this.$store.state.Options.Ethnicities;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            AgencyOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramAgencyOptions"](this.NewClientData.SubProgramID);
            },
            PlacementOptions: function () {
                let options = [];
                this.AvailablePlacements.forEach(function (item) {
                    options.push({
                        text: item.FosterResourceFamilyName,
                        value: item.FosterResourceFamilyID
                    });
                });
                return options;
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
     .vue-datatable {
        width: 100%;
        display: inline-block;
        overflow-x: auto;
    }
</style>